import {FormEvent, useEffect, useState} from "react";
import Logo from "../assets/images/iCXeed-logo.png";
import {useNavigate} from "react-router-dom";

const LoginPage = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState<string>("");
  const [message, setMessage] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false); // Loading state

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
  };

  useEffect(() => {
    if (localStorage.getItem("cob-authenticated")) {
      navigate("/introduction");
    }
  }, [navigate]);

  const onSubmitHandler = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (password === "!nnov@tion2025") {
      setIsLoading(true);
      localStorage.setItem("cob-authenticated", "true");
      setTimeout(() => {
        setIsLoading(false);
        navigate("/introduction");
      }, 2000);
    } else {
      setMessage(true);
      setTimeout(() => {
        return setMessage(false);
      }, 3000);
    }
  };

  return (
    <div className="main-container-blk">
      <div className="login-form-blk">
        <form onSubmit={onSubmitHandler}>
          <img alt="iCXeed Logo" src={Logo} />
          <label>Enter Password</label>
          <input
            type="password"
            name="password"
            value={password}
            onChange={onChangeHandler}
          />
          <button type="submit" disabled={isLoading}>
            {isLoading ? "Loading..." : "Login"}
          </button>
          {message && !isLoading ? (
            <div className="message-blk-login">
              <p>Incorrect password. Try again.</p>
            </div>
          ) : null}
        </form>
        {isLoading && (
          <div className="loading-bar">
            <div className="loading-progress"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginPage;
